import React, { useState, useRef } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

const ChatInput = ({ sendMessage }) => {
    const [message, setMessage] = useState('');
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            sendMessage(message, files);
            setMessage(''); // Clear the input after sending
            setFiles([]); // Clear the files after sending
        }
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
        // setFiles([...event.target.files]);
    };

    const onRemove = (fileToRemove) => {
        // Check if the file name exists in the current input value
        if (fileInputRef.current.value.includes(fileToRemove.name)) {
            fileInputRef.current.value = '';
        }
        setFiles(files.filter((file) => file.name !== fileToRemove.name));
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleSendMessage = () => {
        sendMessage(message, files);
        setMessage(''); // Clear the input after sending
        setFiles([]); // Clear the files after sending
        if(fileInputRef?.current?.value) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className='w-full'>
            {/* Loop through the files and display each */}
            {files.length > 0 && files.map((file, index) => (
                <div key={index} className="file-info flex" style={{ padding: '12px' }}>
                    <i
                        className="pi pi-file-excel"
                        style={{ fontSize: '2em', marginRight: '10px' }}
                    ></i>
                    <div>
                        <div className='font-light text-color-secondary'>{file.name}</div>
                    </div>
                    <i 
                        className="pi pi-times-circle cursor-pointer" 
                        style={{ fontSize: '1rem' }} 
                        onClick={() => onRemove(file)}
                    ></i>
                </div>
            ))}

            <div
                className="p-inputgroup"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px',
                    borderTop: '1px solid #ddd',
                }}
            >
                <InputTextarea
                    rows={1}
                    placeholder="Type a message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                    style={{
                        flex: 1,
                        border: 'none',
                        borderRadius: '20px',
                        padding: '10px',
                    }}
                />
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    multiple // Enable multiple file selection
                />
                <Button
                    icon="pi pi-paperclip"
                    className="p-button-text"
                    style={{ marginLeft: '10px' }}
                    onClick={triggerFileInput}
                />
                <Button
                    icon="pi pi-send"
                    className="p-button-text"
                    style={{ marginLeft: '10px' }}
                    onClick={handleSendMessage}
                />
            </div>
        </div>
    );
};

export default ChatInput;
